import { useRef } from 'react';
import classNames from 'classnames/bind';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';

import Styles from '../../story-filters-styles.module.scss';
import withComponentName from '../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

const RenderCustomHeader = (props) => {
  const {
    date, increaseMonth, decreaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled,
  } = props;
  return (
    <div className={Styles.datepicker_month_header}>
      <div className={cx('datepicker_month_left', { disable: prevMonthButtonDisabled })}>
        <FontAwesomeIcon icon={faChevronLeft} onClick={decreaseMonth} />
      </div>
      <div className={cx('datepicker_month_right', { disable: nextMonthButtonDisabled })}>
        <FontAwesomeIcon icon={faChevronRight} onClick={increaseMonth} />
      </div>
      <div className={Styles.datepicker_month_header_text}>
        {moment(date).format('MMM YYYY')}
      </div>
    </div>
  );
};

const CalendarMobileItem = (props) => {
  const calendarRef = useRef(null);

  const closeCalendarOnClick = (e) => {
    const { visibleEndInput, visibleStartInput } = props;

    // prevent closing mobile calendars when clicking on date input
    if (visibleEndInput && e.target.name === 'endDate') return;
    if (visibleStartInput && e.target.name === 'startDate') return;
  };

  const {
    startDate,
    endDate,
    onDatesChange,
    minDate,
    maxDate,
    calendarTypeOpened,
    buttonErr,
  } = props;

  return (
    <div className={cx({ 'mobile-calendar-error-margin': buttonErr })}>
      <DatePicker
        selected={startDate}
        onChange={(date) => onDatesChange(date, 'startDate', 'inputStartDateValue', 'startTime')}
        selectsStart
        maxDate={maxDate}
        startDate={startDate}
        minDate={minDate}
        inline
        className={Styles['custom-datepicker']}
        dateFormat="dd/MM/yyyy"
        ref={calendarRef}
        onClickOutside={closeCalendarOnClick}
        renderCustomHeader={RenderCustomHeader}
      />
      <DatePicker
        selected={endDate}
        onChange={(date) => onDatesChange(date, 'endDate', 'inputEndDateValue', 'endTime')}
        selectsEnd
        maxDate={maxDate}
        endDate={endDate}
        minDate={startDate}
        inline
        className={Styles['custom-datepicker']}
        dateFormat="dd/MM/yyyy"
        ref={calendarRef}
        onClickOutside={closeCalendarOnClick}
        renderCustomHeader={RenderCustomHeader}
      />
    </div>
  );
};

export default withComponentName(CalendarMobileItem);
